/**
 * Generated from the immutable C# PrivilegeCatalog. Do not hand-edit.
 */
export const PRIVILEGE_CATALOG_VERSION = '6f4085bed3228caaced599ac08c0918c0160b4229511cd737990a4b71b22513a';

export const PRIVILEGES = {
  availabilityDistributionEdit: 'AvailabilityDistribution.Edit',
  availabilityDistributionFull: 'AvailabilityDistribution.Full',
  availabilityDistributionView: 'AvailabilityDistribution.View',
  cleaningAssignmentsManage: 'Cleaning.Assignments.Manage',
  cleaningOccupancyView: 'Cleaning.Occupancy.View',
  cleaningOwnTaskWork: 'Cleaning.OwnTask.Work',
  cleaningQueueView: 'Cleaning.Queue.View',
  cleaningReportsView: 'Cleaning.Reports.View',
  cleaningTeamsManage: 'Cleaning.Teams.Manage',
  dashboardView: 'Dashboard.View',
  guestExperienceEdit: 'GuestExperience.Edit',
  guestExperienceView: 'GuestExperience.View',
  guestsOperationalContactView: 'Guests.OperationalContact.View',
  guestsPersonalDataView: 'Guests.PersonalData.View',
  propertyGroupsView: 'PropertyGroups.View',
} as const;

export type PrivilegeId = (typeof PRIVILEGES)[keyof typeof PRIVILEGES];

export const PRIVILEGE_CATALOG = [
  { id: PRIVILEGES.availabilityDistributionEdit, area: 'availability-distribution', level: 'edit', requires: [PRIVILEGES.availabilityDistributionView] },
  { id: PRIVILEGES.availabilityDistributionFull, area: 'availability-distribution', level: 'full', requires: [PRIVILEGES.availabilityDistributionEdit] },
  { id: PRIVILEGES.availabilityDistributionView, area: 'availability-distribution', level: 'view', requires: [PRIVILEGES.propertyGroupsView] },
  { id: PRIVILEGES.cleaningAssignmentsManage, area: 'cleaning', level: 'full', requires: [] },
  { id: PRIVILEGES.cleaningOccupancyView, area: 'cleaning', level: 'view', requires: [] },
  { id: PRIVILEGES.cleaningOwnTaskWork, area: 'cleaning', level: 'work', requires: [] },
  { id: PRIVILEGES.cleaningQueueView, area: 'cleaning', level: 'view', requires: [] },
  { id: PRIVILEGES.cleaningReportsView, area: 'cleaning', level: 'full', requires: [] },
  { id: PRIVILEGES.cleaningTeamsManage, area: 'cleaning', level: 'full', requires: [] },
  { id: PRIVILEGES.dashboardView, area: 'dashboard', level: 'view', requires: [] },
  { id: PRIVILEGES.guestExperienceEdit, area: 'guest-experience', level: 'edit', requires: [PRIVILEGES.guestExperienceView] },
  { id: PRIVILEGES.guestExperienceView, area: 'guest-experience', level: 'view', requires: [PRIVILEGES.propertyGroupsView] },
  { id: PRIVILEGES.guestsOperationalContactView, area: 'guests', level: 'operational', requires: [] },
  { id: PRIVILEGES.guestsPersonalDataView, area: 'guests', level: 'personal', requires: [PRIVILEGES.guestsOperationalContactView] },
  { id: PRIVILEGES.propertyGroupsView, area: 'properties', level: 'view', requires: [] },
] as const;

export type PrivilegeCatalogEntry = (typeof PRIVILEGE_CATALOG)[number];
